import React from 'react';

import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';

import useLocalization from 'hooks/useLocalization';
import ContextualInfoPopover from 'ui-component/help/ContextualInfoPopover';

/**
 * אייקון מידע (i) לבורר תבניות — מוצגות תבניות מאושרות בלבד + קישור למסך התבניות.
 */
export default function TemplatesMenuApprovedOnlyInfo() {
  const { currentLocale } = useLocalization();
  const info = currentLocale.templatesMenu.filters.approvedOnlyInfo;

  return (
    <ContextualInfoPopover
      title={info.title}
      hoverHint={info.hoverHint}
      size="dense"
      body={
        <>
          <Typography variant="body2" sx={{ lineHeight: 1.6, color: 'text.secondary' }}>
            {info.body}
          </Typography>
          <Link
            component={RouterLink}
            to="/templates/list"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ display: 'inline-block', mt: 1.5, fontWeight: 600, fontSize: '0.8125rem' }}
          >
            {info.linkTemplatesHome}
          </Link>
        </>
      }
    />
  );
}
